import { render, staticRenderFns } from "./AAsignacionSedeV2.vue?vue&type=template&id=7efec4dc&scoped=true"
import script from "./AAsignacionSedeV2.vue?vue&type=script&lang=js"
export * from "./AAsignacionSedeV2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionSedeV2.vue?vue&type=style&index=0&id=7efec4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efec4dc",
  null
  
)

export default component.exports